export default __webpack_public_path__ + "static/media/Boots of the Proven Champion.6a24d0b5.jpg";